module.exports = __webpack_public_path__ + "static/media/panama.c7089042.mp3";